import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";

export const rootContainer = css({
  display: "inline-flex",
  flexDirection: "column",
  minWidth: 136,
  height: "fit-content",
});

export const numberInputsContainer = css({
  display: "flex",
  gap: 5,
  alignItems: "center",
  marginBottom: 10,
});

export const hyphen = (theme: ExactTheme) =>
  css({ height: 1, width: 8, backgroundColor: theme.colorsV2.grey[800] });

export const sliderRoot = css({
  position: "relative",
  display: "flex",
  alignItems: "center",
  userSelect: "none",
  touchAction: "none",
  height: 20,
});

export const sliderTrack =
  ({ disabled }: { disabled: boolean }) =>
  (theme: ExactTheme) =>
    css({
      position: "relative",
      flexGrow: 1,
      borderRadius: theme.borderRadiusV2.fullRounded,
      height: 3,
      backgroundColor: disabled
        ? theme.colorsV2.grey[100]
        : theme.colorsV2.grey[100],
    });

export const sliderRange =
  ({ disabled }: { disabled: boolean }) =>
  (theme: ExactTheme) =>
    css({
      position: "absolute",
      borderRadius: theme.borderRadiusV2.fullRounded,
      height: "100%",
      backgroundColor: disabled
        ? theme.colorsV2.grey[100]
        : theme.colorsV2.blue[200],
    });

export const sliderThumb =
  ({ disabled }: { disabled: boolean }) =>
  (theme: ExactTheme) =>
    css({
      display: "block",
      width: 15,
      height: 15,
      borderRadius: theme.borderRadiusV2.circle,
      transition: "box-shadow 150ms ease-out",
      outline: "none",
      cursor: disabled ? "not-allowed" : "pointer",
      backgroundColor: disabled
        ? theme.colorsV2.grey[200]
        : theme.colorsV2.blue[500],

      ...(!disabled && {
        "&:hover": { boxShadow: theme.shadowV2.sliderThumb },
        "&:active": { boxShadow: theme.shadowV2.sliderThumbActive },
      }),
    });
